export enum StorageType {
    DIG= "DIG",
    Google = "Google",
    Sharepoint = "Sharepoint"
}
